export default __webpack_public_path__ + "static/media/logo_white.dbaab510.svg";